import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useTranslate, } from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
const useStyles = makeStyles((theme) => ({
    Close: {
        fontFamily: "UniviaPro",
        fontSize: '10px',
        letterSpacing: '0.4px ',
        lineHeight: '12.5px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
    }
}))
function Index({ popupState, children }) {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <CustomPopoverArrow
            zIndex={1500}
            popupState={popupState}
            placement='right-start'
        >
            <Paper style={{ width: 180 }}>
                {children}
                <Box display='flex' justifyContent='flex-end'>
                    <Button
                        color='primary'
                        type='button'
                        style={{ marginRight: '1rem', marginBottom: 10 }}
                        onClick={popupState.close}
                    ><Typography className={classes.Close}>{translate('pos.common.cancel')}</Typography></Button>
                </Box>
            </Paper>
        </CustomPopoverArrow>
    )
}

Index.propTypes = {
}

export default Index;
